module.exports = __webpack_public_path__ + "static/media/bg-login.23b3d162.png";